



























































































import { Component, Vue } from "vue-property-decorator";
import {
  ProjectFilter,
  doesProjectMatchFilter,
} from "@/data/models/ProjectFilter";

import { getLogoFile, getClientInfo, getMemberClientIds } from "@/data/repository/ClientRepository";
import { formatLocationInfo } from "@/utils/LocalisationHelper";
import { observePanelsOfClient } from "@/data/repository/PanelRepository";
import { observeComBoxesOfClient } from "@/data/repository/ComBoxRepository";
import { observeClientPanelsWithCurrentProject } from "@/data/repository/ClientPanelRepository";
import { ButtonState } from "@/components/common/StateButton.vue";

import router from "@/router/router";

import {
  observeRecentlyFinishedDryingProjects,
  observeRunningDryingProjects,
  observeRecentlyFinishedLeakDetectionProjects,
  observeRunningLeakDetectionProjects,
} from "@/data/repository/ProjectOverviewRepository";

import { DryingProjectOverview } from "@/data/models/DryingProjectOverview";
import LeakDetectionProjectOverview from "@/data/models/LeakDetectionProjectOverview";
import { ProjectsModule } from "@/store/modules/ProjectsModule";
import { Panel } from "@/data/models/Panel";
import { ComBox } from "@/data/models/ComBox";
import { ClientPanel } from "@/data/models/ClientPanel";
import { DeviceFilter, matchesIresDeviceFilter } from "@/data/models/DeviceFilter";
import { UserModule } from "@/store/modules/UserModule";
import { getUserDisplayName } from "@/utils/UserUtils";

import CompanyHeaderComponent from "@/components/common/CompanyHeader.vue";

import * as _ from "lodash";
import {
  getActiveUser,
  getDefaultBranchFilterOfUser,
} from "@/data/repository/UserRepository";
import { IresDevice } from "@/data/models/IresDevice";
import { FinishedProjectsSettingsModule } from "@/store/modules/FinishedProjectsSettingsModule";
import AppBarLogoComponent from "@/components/common/AppBarLogo.vue";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  components: {
    "company-header": CompanyHeaderComponent,
    "app-bar-logo": AppBarLogoComponent,
  },
})
export default class OverviewComponent extends Vue {
  logo = getLogoFile();

  selectedBranchFilter = getDefaultBranchFilterOfUser();
  clientInfo = getClientInfo();

  panels: Array<Panel> = [];
  comBoxes: Array<ComBox> = [];

  clientPanels: Array<ClientPanel> = [];
  subscriptions: Array<() => void> = [];

  navigationButtonState = ButtonState.LINK;

  activeUser = getActiveUser();
  // Whose panels: the chosen user's while "Sicht auf" is active (ticket 2610052).
  effectiveUser = getEffectiveUser();

  get memberClientIds() {
    return getMemberClientIds();
  }

  get signedInAsText() {
    const parts: string[] = [];
    const clientName = this.clientInfo?.clientName;

    if (clientName) {
      parts.push(clientName);
    }

    const activeUser = UserModule.activeUser;

    if (!activeUser) {
      return clientName ?? null;
    }

    const userName = activeUser ? getUserDisplayName(activeUser) : "Master";
    parts.push(this.$t("common.signedInAs", [userName]).toString());

    return parts.join(", ");
  }

  get projectsInfo() {
    const recentlyFinishedDryingProjects =
      ProjectsModule.recentlyFinishedDryingProjects;

    const recentlyFinishedLeakDetectionProjects =
      ProjectsModule.recentlyFinishedLeakDetectionProjects;

    const recentDryingProjects = [
      ...ProjectsModule.runningDryingProjects,
      ...recentlyFinishedDryingProjects,
    ];

    const recentLeakDetectionProjects = [
      ...ProjectsModule.runningLeakDetectionProjects,
      ...recentlyFinishedLeakDetectionProjects,
    ];

    const recentProjects = [
      ...recentDryingProjects,
      ...recentLeakDetectionProjects,
    ];

    return [
      {
        numProjects: this.getNumProjects(
          ProjectFilter.ALL_PROJECTS,
          recentProjects
        ),
        withDevice: this.getNumProjects(
          ProjectFilter.PROJECTS_WITH_DEVICES_OR_FINISHED_PROJECTS,
          recentProjects
        ),
        overdue: this.getNumProjects(
          ProjectFilter.OVERDUE_PROJECTS_OR_PROJECTS_MOVED_TO_FINISHED,
          recentProjects
        ),
        recentlyFinished: this.getNumProjects(
          ProjectFilter.RECENTLY_FINISHED_PROJECTS_OR_RESTORED_PROJECTS,
          recentProjects
        ),
      },
    ];
  }

  getNumProjects(
    filter: ProjectFilter,
    projects: Array<DryingProjectOverview | LeakDetectionProjectOverview>
  ) {
    return projects
      .filter((project) => doesProjectMatchFilter(filter, project, this.recentlyFinishedProjectsThreshold))
      .length.toString();
  }

  get hyDryDeviceInfo() {
    const panels = this.panels;
    const comBoxes = this.comBoxes;

    const hyDryDevices = [...panels, ...comBoxes];

    if (hyDryDevices.length === 0) {
      return [];
    }

    const clientPanels = _.keyBy(
      this.clientPanels,
      (clientPanel) => clientPanel.serialNumber
    );

    const panelInfo = {
      deviceType: this.$t("overview.deviceTypeHyDryPanels").toString(),
      num: panels.length.toString(),
      numInUsage: this.getNumPanels(
        DeviceFilter.IN_USAGE,
        panels,
        clientPanels
      ),
      numPowerdOn: this.getNumPanels(
        DeviceFilter.ALL_ACTIVE_DEVICES,
        panels,
        clientPanels
      ),
      numIdle: this.getNumPanels(
        DeviceFilter.ALL_FINISHED_DEVICES,
        panels,
        clientPanels
      ),
      numErrorOrWarning: this.getNumPanels(
        DeviceFilter.DEVICES_WITH_ERROR_OR_WARNING,
        panels,
        clientPanels
      ),
      numOverdue: this.getNumPanels(
        DeviceFilter.OVERDUE_DEVICES,
        panels,
        clientPanels
      ),
    };

    const comBoxInfo = {
      deviceType: this.$t("overview.deviceTypeHyDryComBoxes").toString(),
      num: comBoxes.length.toString(),
      numInUsage: this.getNumPanels(
        DeviceFilter.IN_USAGE,
        comBoxes,
        clientPanels
      ),
      numPowerdOn: this.getNumPanels(
        DeviceFilter.ALL_ACTIVE_DEVICES,
        comBoxes,
        clientPanels
      ),
      numIdle: this.getNumPanels(
        DeviceFilter.ALL_FINISHED_DEVICES,
        comBoxes,
        clientPanels
      ),
      numErrorOrWarning: this.getNumPanels(
        DeviceFilter.DEVICES_WITH_ERROR_OR_WARNING,
        comBoxes,
        clientPanels
      ),
      numOverdue: this.getNumPanels(
        DeviceFilter.OVERDUE_DEVICES,
        comBoxes,
        clientPanels
      ),
    };

    return [panelInfo, comBoxInfo];
  }

  getNumPanels(
    filter: DeviceFilter,
    iresDevices: Array<IresDevice>,
    // eslint-disable-next-line
    clientPanels: any
  ) {
    return iresDevices
      .filter((panel) => matchesIresDeviceFilter(filter, panel, this.effectiveUser))
      .length.toString();
  }

  get showHyDryDevicesInfo() {
    return this.hyDryDeviceInfo.length > 0;
  }

  get clientName() {
    const clientInfo = this.clientInfo;

    if (!clientInfo) {
      return "";
    }

    if (!clientInfo.companyName || clientInfo.companyName === "") {
      return clientInfo.clientName;
    }

    return clientInfo.companyName;
  }

  get clientAddress() {
    const clientInfo = this.clientInfo;

    if (!clientInfo) {
      return "";
    }

    return formatLocationInfo(clientInfo);
  }

  get showLogo() {
    return !!this.logo;
  }

  get recentlyFinishedProjectsThreshold() {
    return FinishedProjectsSettingsModule.finishedProjectsSettings.recentlyFinishedProjects;
  }

  openProjects() {
    router.push({ path: "/main/projects" });
  }

  openDevices() {
    router.push({ path: "/main/devices" });
  }

  created() {
    this.subscriptions.push(
      observePanelsOfClient(this.effectiveUser?.id, (panels: Array<Panel>) => {
        this.panels = panels;
      })
    );

    this.subscriptions.push(
      observeComBoxesOfClient(
        this.effectiveUser?.id,
        (comBoxes: Array<ComBox>) => {
          this.comBoxes = comBoxes;
        }
      )
    );

    this.subscriptions.push(
      observeClientPanelsWithCurrentProject(
        (clientPanels: Array<ClientPanel>) => {
          this.clientPanels = clientPanels;
        }
      )
    );

    this.subscriptions.push(observeRunningDryingProjects());
    this.subscriptions.push(observeRecentlyFinishedDryingProjects(this.recentlyFinishedProjectsThreshold));
    this.subscriptions.push(observeRunningLeakDetectionProjects());
    this.subscriptions.push(observeRecentlyFinishedLeakDetectionProjects(this.recentlyFinishedProjectsThreshold));
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => subscription());
  }
}
